import { Route, Routes } from "react-router-dom";
import { PTLI0301001Q } from "@/tra/tancis/ptli/mypage/todo/PTLI0301001Q";
import { PTLI03040001Q } from "@/tra/tancis/ptli/mypage/myiqs/PTLI03040001Q";
import { PTLI03040002S } from "@/tra/tancis/ptli/mypage/myiqs/PTLI03040002S";
import { PTLI03040003S } from "@/tra/tancis/ptli/mypage/myiqs/PTLI03040003S";
import { PTLI03040004Q } from "@/tra/tancis/ptli/mypage/myiqs/PTLI03040004Q";
import { PTLI0307001S } from "@/tra/tancis/ptli/mypage/myinfochg/PTLI0307001S";
import { PTLI0308001Q } from "@/tra/tancis/ptli/mypage/notihist/PTLI0308001Q";
import { PTLI0308002Q } from "@/tra/tancis/ptli/mypage/notihist/PTLI0308002Q";
import { PTLI0315001Q } from "@/tra/tancis/ptli/mypage/apitknmng/PTLI0315001Q";
import { PTLI0305001Q } from "../mypage/surv/PTLI0305001Q";



/*
 * 응용기능별 Router
 * - 명명규칙 : 응용기능 2 레벨 메타 단어(용어) 카멜표기(첫글자 대문자) + Router
 * - 응용기능 2 레벨 별로 Router 분리 원칙(기본)
 * - 응용기능 레벨별로 소문자로 구분하여 경로 작성
 * - 최종 라우팅하는 주소는 화면 아이디에서 '-' 구분자를 빼고 소문자로 변환하여 작성
 * - element 에 해당 화면 컴포넌트 기입
 * - 화면에서 파라메터로 받아서 사용할 키값은 path 문자열에 ':변수명' 으로 기입하여 해당 컴포넌트 인지하여 사용
 * TODO URL의 'key' 를 실제 ID로 변경 하세요.
 * TODO 위의 한글 주석은 마지막에 전부 삭제하세요.
 */
export const MyPageRouter = () => {
    return (
        <Routes>
            {/** ==================== Apply for User Registration START ==================== */}

            {/* Check user registration application information !== 사용자 등록 신청 정보 조회 ==! */}
            <Route path={"/todo/ptli0301001q"} element={<PTLI0301001Q />} />

            {/** ==================== Apply for User Registration END ==================== */}

            {/** ==================== IQS START ==================== */}
            {/* My IQS List !== 나의 IQS 목록 ==! */}
            <Route path={"/myiqs/ptli0304001q"} element={<PTLI03040001Q />} />
            {/* My IQS Details !== 나의 IQS 상세 ==! */}
            <Route path={"/myiqs/ptli0304002s/:iqsUuid"} element={<PTLI03040002S />} />
            {/* IQS Registration(Connecting to other systems) !== 나의 IQS 등록 (타시스템 연계)==! */}
            <Route path={"/myiqs/ptli0304003s"} element={<PTLI03040003S />} />
            {/* My IQS Details (Connecting to other systems) !== 나의 IQS 상세 (타시스템 연계)==! */}
            <Route path={"/myiqs/ptli0304004q/:bsopId"} element={<PTLI03040004Q />} />
            {/** ==================== IQS START END ==================== */}

            {/** ==================== Notification status (SMS/Email) Router START ==================== */}

            {/* Select. Notifice History List !== 알림현황(SMS/Email) 목록 조회 ==! */}
            <Route path={"/notihist/ptli0308001q"} element={<PTLI0308001Q />} />
            {/* Notifice History Details !== 알림현황(SMS/Email) 상세 ==! */}
            <Route path={"/notihist/ptli0308002q/:notiSendUuid"} element={<PTLI0308002Q />} />

            {/** ==================== Notification status (SMS/Email) Router END ==================== */}

            {/** ==================== my information change Router START ==================== */}
            {/* my information change !== 나의 정보 수정 ==! */}
            <Route path={"/myinfochg/PTLI0307001S/:usrDmnId"} element={<PTLI0307001S />} />
            {/** ==================== my information change Router END ==================== */}

            {/** ==================== Api Token Management Router START ==================== */}
            {/* Api Token Management !== Api 토큰 관리 ==! */}
            <Route path={"/apitknmng/ptli0315001q"} element={<PTLI0315001Q />} />
            {/** ==================== my information change Router END ==================== */}

            {/* Survey Participation !== 설문 참여 ==! */}
            <Route path={"/surv/ptli0305001q"} element={<PTLI0305001Q />} />

        </Routes>
    );
};
